export default $(document).ready(e => {
    const geocode_url = "/api/v1/geocode";
    const form = $('#addressform');
    const loader = $('#loading');
    const btn_geocode = $('#btn_geocode');
    const geocode_result = $("#geocode_result");

    loader.hide();

    btn_geocode.click(e => {
        e.preventDefault();
        let formData = form.serializeArray();

        $.ajax({
            url: geocode_url,
            type: "GET",
            data: formData,
            beforeSend: function () {
                geocode_result.html('');
                loader.show();
                btn_geocode.attr("disabled", true);
            },
            complete: function () {
                loader.hide();
                btn_geocode.attr("disabled", false);
            },
            success: (response_data) => {
                geocode_result.html(response_data);
            },
            error: response => {
                console.log("failure");
            }
        });
    });
})
